import React from 'react';

const PopoverTrigger = ({ children }) => <div className="ws-ui-popover__trigger">{children}</div>;

export default PopoverTrigger;
